import React from 'react'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { HelperText } from './'
import { useController } from 'react-hook-form'
import withStyles from '@material-ui/styles/withStyles'

const styles = () => ({
  inputLabel: {
    fontSize: '15px',
    transform: 'translate(0, 0) !important',
    marginTop: '-8px'
  }
})

const SelectFieldComponent = (props) => {
  const {
    name,
    control,
    defaultValue,
    label,
    className,
    disabled,
    onChangeOverride,
    onChange,
    children,
    classes,
    labelStyle,
    ...rest
  } = props

  const {
    field,
    fieldState: { invalid, error }
  } = useController({
    name,
    control,
    defaultValue: defaultValue ?? ''
  })

  const handleChange = (e) => {
    if (typeof onChangeOverride === 'function') {
      onChangeOverride(e, field, fieldState)
    } else {
      onChange?.(e)
      field.onChange(e)
    }
  }

  return (
    <FormControl error={invalid} style={{ marginTop: '32px' }}>
      <InputLabel
        shrink
        className={classes.inputLabel}
        style={{ opacity: disabled ? 0.7 : 1, ...labelStyle }}
      >
        {label}
      </InputLabel>
      <Select
        {...field}
        onChange={handleChange}
        className={className}
        disableUnderline={true}
        disabled={disabled}
        inputProps={{
          'aria-label': label
        }}
        {...rest}
      >
        {children}
      </Select>
      <HelperText
        invalid={invalid}
        error={error}
        style={{ marginTop: '0px', height: '0px' }}
      />
    </FormControl>
  )
}

export const HookSelect = withStyles(styles)(SelectFieldComponent)
